export default __webpack_public_path__ + "static/media/ava.2a805193.jpg";